import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { ConfirmProvider } from './components/ConfirmDialog';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Finances from './pages/Finances';
import Lab from './pages/Lab';
import FormulaDetail from './pages/FormulaDetail';
import Production from './pages/Production';
import BatchPage from './pages/BatchPage';
import Products from './pages/Products';
import Invoices from './pages/Invoices';
import InvoiceNew from './pages/InvoiceNew';
import InvoiceDetail from './pages/InvoiceDetail';
import SuppliersOrders from './pages/SuppliersOrders';
import Todo from './pages/Todo';
import Marketing from './pages/Marketing';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        {/* Above the routes so any page can raise a confirmation, and so the
            dialog outlives the component that asked for it. */}
        <ConfirmProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="finances" element={<Finances />} />
            <Route path="lab" element={<Lab />} />
            <Route path="lab/formulas/:id" element={<FormulaDetail />} />
            <Route path="production" element={<Production />} />
            <Route path="production/batches/:id" element={<BatchPage />} />
            {/* The old addresses still work — both partners have them
                bookmarked, and renaming a section shouldn't cost that. */}
            <Route path="formulas" element={<Navigate to="/lab" replace />} />
            <Route path="production-log" element={<Navigate to="/production" replace />} />
            <Route path="products" element={<Products />} />
            <Route path="invoices" element={<Invoices />} />
            {/* Before the :id route, or "new" is read as an invoice id. */}
            <Route path="invoices/new" element={<InvoiceNew kind="Direct" />} />
            <Route path="invoices/new-stockist" element={<InvoiceNew kind="Stockist" />} />
            <Route path="invoices/:id" element={<InvoiceDetail />} />
            <Route path="invoices/:id/edit" element={<InvoiceNew kind="Direct" mode="edit" />} />
            <Route path="suppliers" element={<SuppliersOrders />} />
            {/* Vendors and Purchase Orders merged into Suppliers & Orders;
                the old paths redirect so saved links still work. */}
            <Route path="vendors" element={<Navigate to="/suppliers" replace />} />
            <Route path="purchase-orders" element={<Navigate to="/suppliers" replace />} />
            <Route path="todo" element={<Todo />} />
            {/* The link inside a Google Calendar event points here, so it
                has to open the task it names rather than a blank page. */}
            <Route path="todo/:taskId" element={<Todo />} />
            <Route path="marketing" element={<Marketing />} />
          </Route>
        </Routes>
        </ConfirmProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
